// removed by extract-text-webpack-plugin
module.exports = {"progress":"_3-5f3obrKRgE-Djmc4XwU8","spin":"_3tZfHwaXI6yzbZG6Ax2-x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Loading/style.css
// module id = 228
// module chunks = 42